
class TeamComparisonModel{
  constructor (payload) {
      const { data  = {}} = payload;
    this.data = data;
  } 
}

export default TeamComparisonModel;